// extracted by mini-css-extract-plugin
export var currencyInput = "_m8-1";
export var currencySymbol = "_m8-0";